import { Container, Row, Col, Button  } from 'react-bootstrap';
import bookit from './assets/Il-tasto-giusto-Caterina-Vivarelli.jpg';
import booken from './assets/THE_RIGHT_KEY_pdf (1)_page-0001.jpg';
import bookPDFit from './assets/IL_TASTO_GIUSTO_Caterina_Vivarelli.pdf';
import bookPDFen from './assets/THE_RIGHT_KEY_Caterina_Vivarelli.pdf';
import { useTranslation } from 'react-i18next';

export default function BannerMetodo({ title, author, description, download, currentPage }) {
    const { t, i18n } = useTranslation();
    const bookPDF = i18n.language === 'it' ? bookPDFit : bookPDFen;
    const book = i18n.language === 'it' ? bookit : booken;

    let downloadLink;
    let downloadText;

    if (currentPage === '/') {
        downloadLink = '/lezioni';
        downloadText = t('banner.downloadLink');
    } else if (currentPage === '/lezioni') {
        downloadLink = bookPDF;
        downloadText = t('banner.downloadLink');
    }
    

    return (
    <div className='bg-accent py-4'>
        <Container>
        <Row className="h-100 justify-content-center align-items-center">
            <Col lg={2} className="d-flex h-100 justify-content-center align-items-center align-items-lg-start">
            <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                <img className='mx-auto d-block img-fluid rounded-3' style={{ height: '100%' }} src={book} alt="book" />
            </div>
            </Col>
            <Col lg={10} className='d-flex flex-column justify-content-center align-items-center align-items-lg-start'>
            <p className='display-6 fw-bold text-light mb-0 mt-3 mt-lg-0'>{t('banner.title')}</p>
            <p className='lead mt-1 text-light opacity-75'>{t('banner.author')}</p>
            <p className='small text-light text-center text-lg-start mb-0'>{t('banner.description')}</p>
            <p className='small text-light text-center text-lg-start mb-0'>{currentPage === "/" ? t('banner.visitLink') : t('banner.download')} ‎
                <a data-aos="fade-up" data-aos-delay="500" target='_blank' rel='noreferrer' className='fw-bolder rounded-2 text-light' href={downloadLink}>
                {downloadText}
                </a>.
            </p>
            </Col>
        </Row>
        </Container>
    </div>
    );
}